import React, { useEffect, useState } from "react";

export default function SubmissionList({ refresh }) {
  const [data, setData] = useState([]);
 const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://u2uprojects.coreaidataedge.com";

useEffect(() => {
  fetch(`${API_URL}/submissions`)
   // .then((res) => res.json())
    .then((res) => res.json())
      .then((res) => {
        // Remove completely empty records
        const filteredData = (res || []).filter(
          (item) =>
            item.ProjectTitle ||
            item.GroupNumber ||
            item.StudentName ||
            item.Email ||
            item.Description ||
            item.UploadedFile
        );

        setData(filteredData);
      })
      .catch((err) => console.error(err));
   // .then((res) => setData(res || []))
  //  .catch((err) => console.error(err));
}, [refresh]);
  return (
    <div>
      <h2>Submitted Projects</h2>

      {data.map((item, index) => (
        <div
          key={index}
          style={{
            border: "1px solid #ccc",
            margin: "10px",
            padding: "10px"
          }}
        >
          <h3>{item.ProjectTitle}</h3>
 <p>
            <b>Group:</b> {item.GroupNumber}</p>
          <p>
            <b>Submitted By:</b> {item.StudentName}
          </p>

          <p>
            <b>Email:</b> {item.Email}
          </p>
          <p>
            <b>Submission Number: </b>{item.Description}</p>

          {item.UploadedFile && (
            <p>
              <b>File Submitted:</b> {item.UploadedFile}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}